<template>
  <div id="app">
    <Navbar/>
    <div class="content">
      <CookieConsent/>
      <keep-alive>
        <router-view></router-view>
      </keep-alive>
    </div>
    <Footer/>
  </div>
</template>

<script>
import Navbar from './components/Navbar';
import CookieConsent from './components/CookieConsent';
import Footer from './components/Footer';

import './assets/css/global.scss';

export default {
  name: 'App',
  components: {
    Navbar,
    CookieConsent,
    Footer,
  },
  data() {
    return {
      locales: [
        {
          key: 'en',
          name: 'English (UK)',
        },
        {
          key: 'de',
          name: 'Deutsch (Deutschland)',
        },
      ],
    };
  },
};
</script>

<style>
/* see ./assets/css/global.scss for global styles */
</style>



// WEBPACK FOOTER //
// src/App.vue